import { render } from "./SystemConfigSettings.vue?vue&type=template&id=0e9cc1c6&scoped=true"
import script from "./SystemConfigSettings.vue?vue&type=script&lang=js"
export * from "./SystemConfigSettings.vue?vue&type=script&lang=js"

import "./SystemConfigSettings.vue?vue&type=style&index=0&id=0e9cc1c6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e9cc1c6"]])

export default __exports__